import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Vant from 'vant';
import 'vant/lib/index.css';
import axios from 'axios';

// 全局 Design Token
import './assets/design-tokens.css';

// 全局 SVG 图标组件
import LucideIcon from './components/icons/LucideIcon.vue';
Vue.component('LucideIcon', LucideIcon);

Vue.prototype.$axios = axios;
Vue.use(Vant);

new Vue({
  render: h => h(App),
  router
}).$mount('#app');